<!-- 车辆通行记录页面 -->
<template>
  <div class="access-record-container">
    <!--主页面 -->
    <div class="flex-row" style="height: 100%">
      <div class="flex-auto flex-valign" style="overflow: hidden">
        <!-- 右侧表格 -->
        <div class="section-main_table">
          <ioc-table ref="accessTab" :data="tableData" :option="tableOption" :page="page" @row-cancle="closeDialog"
            @search-change="searchResult" @search-reset="resetQuery" @current-change="selectPage"
            @size-change="changeSize">
            <!-- 车辆类型 -->
            <template slot="search_carType">
              <div>
                <el-select v-model="searchParams.carType" placeholder="请选择" clearable>
                  <el-option v-for="item in carTypeOptions" :key="item.value" :label="item.label" :value="item.value">
                  </el-option>
                </el-select>
              </div>
            </template>

            <!-- 上方按钮 -->
            <!-- <template slot="menuLeft">
              <el-button
                size="small"
                icon="el-icon-delete"
                class="iss-operation-button"
                @click="handelExportRecord"
              >
                导出
              </el-button>
            </template> -->
            <template slot="menu" slot-scope="scope">
              <el-tooltip class="item" effect="dark" content="详情" placement="top" popper-class="tooltip-draw">
                <el-button type="text" icon="iconfont icon-Detail"
                  @click="handleView(scope.row, scope.index)"></el-button>
              </el-tooltip>
              <el-tooltip class="item" effect="dark" content="强制出场" placement="top" popper-class="tooltip-draw"
                v-if="scope.row.carStatus === '0'">
                <el-button type="text" icon="el-icon-s-open" @click="handleUpdateVehicle(scope.row)"></el-button>
              </el-tooltip>
            </template>
            <!-- 入场图片 -->
            <template slot="realCapturePicPathEnter" slot-scope="scope">
              <img :src="scope.row.enterImg" onerror="this.src='/images/theme/newDark/default.png'"
                style="height: 50px; width: 50px" @click="showViewer(scope.row.enterImg, $event)" />
            </template>
            <!-- 出场图片 -->
            <template slot="realCapturePicPathExit" slot-scope="scope">
              <img :src="scope.row.exitImg" onerror="this.src='/images/theme/newDark/default.png'"
                style="height: 50px; width: 50px" @click="showViewer(scope.row.exitImg, $event)" />
            </template>
            <!-- 车牌号点击可以跳转详情页面 -->
            <template slot="plateCode" slot-scope="scope">
              <span style="cursor: pointer" @click="handleView(scope.row, scope.index)">{{ scope.row.plateCode }}</span>
            </template>
            <!-- 查看详情表单 自定义 -->
            <!-- <template slot="trafficFileCodeView" slot-scope="scope">
              <img
                :src="getImgPath(scope.row.trafficFileCode)"
                onerror="this.src='/images/theme/newDark/default.png'"
                style="height: 50px; width: 50px"
                @click="
                  showViewer(getImgPath(scope.row.trafficFileCode), $event)
                "
              />
            </template> -->
          </ioc-table>
        </div>
      </div>
    </div>
    <!--详情-->
    <appPanel :width="700" class="app-panel" :isExpand="showPanel" @cancel="handleClosePanel" title="通行记录详情">
      <div class="panel-content">
        <!-- <el-scrollbar style="height: 100%"> -->
        <div class="content-top">
          <div class="detail-info">
            <el-row>
              <el-col :span="12">
                <div class="info-item">
                  <span class="label">车牌号码：</span>
                  <span class="item-value">{{ form.enterCarNum }}</span>
                </div>
              </el-col>
              <el-col :span="12">
                <div class="info-item">
                  <span class="label">用户部门: </span>
                  <span class="item-value">{{ form.deptName }}</span>
                </div>
              </el-col>
            </el-row>

            <el-row>
              <el-col :span="12">
                <div class="info-item">
                  <span class="label">入场道闸名称：</span>
                  <span class="item-value">{{
                    form.enterSluiceDevChnname
                    ? form.enterSluiceDevChnname
                    : "暂无"
                  }}</span>
                </div>
              </el-col>
              <el-col :span="12">
                <div class="info-item">
                  <span class="label">车主姓名：</span>
                  <span class="item-value">{{
                    form.ownerName ? form.ownerName : "暂无"
                  }}</span>
                </div>
              </el-col>
            </el-row>

            <el-row>
              <el-col :span="12">
                <div class="info-item">
                  <span class="label">停车场名称：</span>
                  <span class="item-value">{{
                    form.parkingLot ? form.parkingLot : "暂无"
                  }}</span>
                </div>
              </el-col>
            </el-row>

            <el-row>
              <el-col :span="12">
                <div class="info-item">
                  <span class="label">出入场类型：</span>
                  <span class="item-value">{{
                    form.carStatus == 0 ? '入场' : form.carStatus == 1 ? '出场' : form.carStatus == 2 ? '只有出场' : '强制出场'
                  }}</span>
                </div>
              </el-col>
              <el-col :span="12">
                <div class="info-item">
                  <span class="label">车辆类型：</span>
                  <span class="item-value">{{
                    form.carType == 0
                    ? "外部车"
                    : form.carType == 1
                      ? "内部车"
                      : "暂无"
                  }}</span>
                </div>
              </el-col>
            </el-row>

            <el-row>
              <el-col :span="12">
                <div class="info-item">
                  <span class="label">入场时间：</span>
                  <span class="item-value">{{ form.enterTime }}</span>
                </div>
              </el-col>
              <el-col :span="12">
                <div class="info-item">
                  <span class="label">出场时间：</span>
                  <span class="item-value">{{ form.exitTime }}</span>
                </div>
              </el-col>
            </el-row>

            <div class="info-item">
              <span class="label">入场图片：</span>
              <span class="item-value">
                <img style="
                    width: 176px;
                    height: 176px;
                    cursor: pointer;
                    position: absolute;
                  " onerror="this.src='/images/theme/newDark/default.png'" :src="imgChange(form.enterImg)"
                  @click="showViewer(imgChange(form.enterImg), $event)" />
              </span>
            </div>
            <div class="info-item" style="margin-top: 160px">
              <span class="label">出场图片：</span>
              <span class="item-value">
                <img style="
                    width: 176px;
                    height: 176px;
                    cursor: pointer;
                    position: absolute;
                  " onerror="this.src='/images/theme/newDark/default.png'" :src="imgChange(form.exitImg)"
                  @click="showViewer(imgChange(form.exitImg), $event)" />
              </span>
            </div>
          </div>
        </div>
        <!-- </el-scrollbar> -->
      </div>
      <div slot="footer">
        <el-button @click="handleClosePanel">关闭</el-button>
      </div>
    </appPanel>
    <el-dialog title="强制出场" :visible.sync="vehicleVisible" append-to-body :close-on-click-modal="false" width="400px"
      :before-close="handleCloseUpdatePanel" @close="handleCloseUpdatePanel">
      <el-form ref="dialogForm" :model="vehicleForm" label-width="110px" :rules="rules">
        <el-form-item label="出场时间" prop="exitTime">
          <el-date-picker type="datetime" placeholder="请选择出场时间" v-model="vehicleForm.exitTime"
            value-format="yyyy-MM-dd HH:mm:ss" :picker-options="pickerOptions" />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="handleConfirm()">确 定</el-button>
        <el-button @click="handleCloseUpdatePanel()">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { api } from "../api/index";
import appPanel from "@src/components/business/app-panel/index.vue";
import { Bus, Dates } from "$utils";
import utils from "@src/common/utils";
import { tableOption } from "../config/table";

export default {
  components: {
    appPanel,
  },
  data() {
    return {
      form: {},
      showPanel: false,
      viewerInstance: null,
      tableOption: tableOption(),
      getTimeOut: null,
      // 分页属性设置
      page: {
        currentPage: 1,
        total: 10,
        pageSize: utils.Cache.get("CURRENT_PAGESIZE") || 10,
      },
      tableData: [],
      searchParams: {},
      carTypeOptions: [
        {
          value: 1,
          label: "内部车",
        },
        {
          value: 0,
          label: "外部车",
        },
      ],
      etcTypeOptions: [
        {
          value: "1",
          label: "是",
        },
        {
          value: "0",
          label: "否",
        },
      ],
      vehicleVisible: false,
      vehicleForm: {
        exitTime: null
      },
      vehicleId: '',
      enterTime: '',
      rules: {
        exitTime: [{ required: true, message: "请选择时间", trigger: "blur" }],
      },
      pickerOptions: {
        disabledDate: (time) => {
          if (this.enterTime && (this.enterTime !== '' || this.enterTime !== null)) {
            return time.getTime() < new Date(this.enterTime).getTime() - 8.64e7
          }
        },
      },
      // visitIp: ''
    };
  },
  beforeDestroy() {
    this.getTimeOut && clearTimeout(this.getTimeOut);
  },
  created() {
    // let hostName = location.href;
    // let ipIndex = hostName.indexOf('/#')
    // if (ipIndex !== -1) {
    //   this.visitIp = hostName.substring(0, ipIndex)
    // }
  },
  mounted() {
    this.getList();
    this.imgChange()
  },
  methods: {
    imgChange(item) {
      if (item != '' && item != null && item != undefined) {
        let imgUrl = item.substring(item.indexOf('/d'))
        return imgUrl
      } else { 
        return ''
      }
    },
    handleConfirm() {
      this.$refs.dialogForm.validate((valid) => {
        if (valid) {
          this.$fetch(api.record.updateVehicleHisRecordList, {
            id: this.vehicleId,
            exitTime: this.vehicleForm.exitTime
          }).then(res => {
            if (res.success) {
              this.handleCloseUpdatePanel();
              this.getList();
            } else {
              this.$message.error(res.msgContent);
            }
          })
        }
      })
    },
    handleCloseUpdatePanel() {
      this.vehicleId = ''
      this.enterTime = ''
      this.$refs.dialogForm.resetFields()
      this.vehicleVisible = false
    },
    handleUpdateVehicle(row) {
      this.vehicleId = row.id
      this.enterTime = row.enterTime
      this.vehicleVisible = true
    },
    handSetTime() {
      if (this.getTimeOut) {
        clearTimeout(this.getTimeOut);
      }
      this.getTimeOut = setTimeout(() => {
        this.getList();
      }, 1000 * 60 * 2);
    },
    getImgPath(item) {
      return item ? Bus.imgPath(item) : "";
    },
    showViewer(url, e) {
      this.$app.AppInstance.handleShowViewer([e.target.src]);
    },
    // 获取车辆记录列表
    getList() {
      const params = {};
      params.pageNum = this.page.currentPage;
      params.pageSize = this.page.pageSize;

      params.carType = this.searchParams.carType;
      params.etcType = this.searchParams.etcType;
      params.carStatus = this.searchParams.carStatus;
      params.ownerLikeStr = this.searchParams.ownerName;

      params.enterTimeStrLeft = this.searchParams.enterStartTime
        ? Dates.format(this.searchParams.enterStartTime)
        : "";
      params.enterTimeStrRight = this.searchParams.enterEndTime
        ? Dates.format(this.searchParams.enterEndTime)
        : "";

      params.exitTimeStrLeft = this.searchParams.exitStartTime
        ? Dates.format(this.searchParams.exitStartTime)
        : "";
      params.exitTimeStrRight = this.searchParams.exitEndTime
        ? Dates.format(this.searchParams.exitEndTime)
        : "";

      const loading = this.$loading({
        lock: true,
        text: "请求中",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      this.$fetch(api.record.record, params).then((response) => {
        loading.close();
        if (!response.success) {
          this.$message.error(response.msgContent);
          return;
        }
        this.handSetTime();
        this.tableData = response.returnObj
          ? Object.freeze([...response.returnObj.list])
          : [];
        this.page.total = response.returnObj ? response.returnObj.total : 0;
        // this.$refs.accessTab.selectClear();
      });
    },

    handleView(row, index) {
      this.showPanel = true;
      this.form = row;
      // console.log(row.trafficFileCode);
      // if (row.trafficFileCode) {
      //   this.form.trafficFileCode =
      //     "/common/file/downLoadFileStream.json?fileCode=" +
      //     row.trafficFileCode;
      // }
      // console.log("...detail", this.showPanel);
      //  this.$refs.accessTab.rowView(row, index);
    },
    //关闭详情
    handleClosePanel() {
      this.showPanel = false;
    },

    closeDialog() {
    },

    // 查询按钮事件
    searchResult(param) {
      console.log("--searchResult()--param:--", param);
      this.searchParams.ownerName = param.ownerName;
      this.searchParams.carStatus = param.carStatus;
      // let tempObj = {};
      // tempObj.startTime = this.searchParams.startTime;
      // tempObj.endTime = this.searchParams.endTime;

      // this.searchParams = Object.assign(param);
      // console.log(this.searchParams, "===query");
      if (param.exitTime && param.exitTime.length > 0) {
        this.searchParams.exitStartTime = param.exitTime[0];
        this.searchParams.exitEndTime = param.exitTime[1];
      }
      if (param.enterTime && param.enterTime.length > 0) {
        this.searchParams.enterStartTime = param.enterTime[0];
        this.searchParams.enterEndTime = param.enterTime[1];
      }
      this.page.currentPage = 1;
      this.getList();
    },
    // 重置按钮
    resetQuery() {
      this.searchParams.exitStartTime = "";
      this.searchParams.exitEndTime = "";
      this.searchParams.enterStartTime = "";
      this.searchParams.enterEndTime = "";
      this.searchParams.ownerName = "";
      this.searchParams.etcType = "";
      this.searchParams.carType = "";
      this.searchParams.carStatus = "";
      this.getList();
    },
    // 点击上一页下一页按钮
    selectPage(val) {
      this.page.currentPage = val;
      this.getList();
    },
    // 修改每页数据数量
    changeSize(val) {
      this.page.currentPage = 1;
      this.page.pageSize = val;
      this.getList();
    },
    // 导出操作
    handelExportRecord() {
      console.log("记录导出操作");
    },
  },
};
</script>
<style lang="scss" scoped>
.panel-content {
  .content-top {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
  }

  .info-item {
    margin: 15px 0px;
    // width: 50%;
  }

  .item-img {
    margin: 15px 0px;
  }

  .label {
    padding: 0 20px;
    width: 100px;
    text-align: center;
  }

  .detail-info {
    width: 100%;
    padding: 0 40px;
    display: flex;
    justify-content: space-between;
    flex-direction: column;
    flex-wrap: wrap;
  }
}

.access-record-container {
  width: 100%;
  height: 100%;

  .el-table__fixed-right-patch {
    display: none;
  }

  .el-dialog {

    .el-date-editor.el-input,
    .el-date-editor.el-input__inner {
      width: 260px;
    }
  }
}
</style>
